import About from "./pages/About";
import Projects from "./pages/Projects";
import Skills from "./pages/Skills";
import { Pages, SocialLink } from "./@types/types";
import {
  greeting,
  fullName,
  role,
  description,
  profileImageUrl,
  skillSet,
  githubUrl,
  linkedInUrl,
} from "./config";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export const socialLinks: SocialLink[] = [
  {
    name: "github",
    icon: <GitHubIcon />,
    url: githubUrl,
    color: "primary",
  },
  {
    name: "linkedin",
    icon: <LinkedInIcon />,
    url: linkedInUrl,
    color: "primary",
  },
];

export const pages: Pages[] = [
  {
    menuTitle: "About",
    pageURL: "#about",
    component: (
      <About
        greeting={greeting}
        fullName={fullName}
        role={role}
        description={description}
        socialLinks={socialLinks}
        profileImageUrl={profileImageUrl}
      />
    ),
  },
  {
    menuTitle: "Skills",
    pageURL: "#skills",
    component: <Skills skills={skillSet} />,
  },
  {
    menuTitle: "Projects",
    pageURL: "#projects",
    component: <Projects />,
  },
];
